// import getEncircledNumber from './getEncircledNumber';
import getNodeConfig from './getNodeConfig';
import getEdgeConfig from './getEdgeConfig';

export default function createNodesAndEdges(
    data, roles = [], nodes = [], edges = [], id = 1000, level = 0, parentId,
) {
    /*console.log(`createNodesAndEdges for data %o, nodes %o, edges %o, roles %o, id %o, level %d, 
        parentId %o`, data, nodes, edges, roles, id, level, parentId);*/
    data.forEach((node, index) => {

        //const roleIndexes = node.roles ? node.roles.map((role) => roles.indexOf(role)) : [];
        //const roleNumbers = roleIndexes.map((index) => getEncircledNumber(index + 1));

        const configuredNode = getNodeConfig(node.name/*+ '   ' + roleNumbers.join(' ')*/, level);
        // Add roles (to filter when hovering)
        configuredNode.roles = node.roles;
        configuredNode.id = id++;
        configuredNode.level = level;
        const configuredEdge = getEdgeConfig(parentId, configuredNode.id, level, index, data.length);
        nodes.push(configuredNode);
        edges.push(configuredEdge);
        if (node.children) {
            const result = createNodesAndEdges(node.children, roles, nodes, edges, id, level + 1, 
                configuredNode.id);
            // Update id to match highest ID that was returned by createNodesAndEdges
            id = result.id;
        }

    });

    return {
        nodes,
        edges,
        roles,
        id,
    };
}
